import { Component } from "../lib/component.ts";
import { observeScroll } from "../lib/scroll-observer.ts";

interface ScentProfileRefs {
  sentinels?: HTMLDivElement[];
}

class ScentProfile extends Component<ScentProfileRefs> {
  static THRESHOLD = 0.12;
  static FADE_DISTANCE = 0.1;

  connectedCallback(): void {
    super.connectedCallback();

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    observeScroll(this, this.#updateOpacities, this.signal);
  }

  #updateOpacities = (): void => {
    if (!this.refs.sentinels?.length) return;

    const viewportCenter = window.innerHeight / 2;

    this.refs.sentinels.forEach((sentinel) => {
      const note = sentinel.parentElement;
      if (!(note instanceof HTMLElement)) return;

      const image = note.querySelector(".scent-profile__image");
      const imageHeight = image instanceof HTMLElement ? image.offsetHeight : note.offsetHeight;
      const threshold = imageHeight * ScentProfile.THRESHOLD;
      const fadeDistance = imageHeight * ScentProfile.FADE_DISTANCE;

      const rect = sentinel.getBoundingClientRect();
      const sentinelCenter = rect.top + rect.height / 2;
      const distance = Math.abs(sentinelCenter - viewportCenter);

      const fadeStart = Math.max(0, distance - threshold);
      const opacity = Math.max(0, 1 - fadeStart / fadeDistance);
      note.style.setProperty("--note-opacity", String(opacity));
    });
  };
}

if (!customElements.get("scent-profile")) {
  customElements.define("scent-profile", ScentProfile);
}
